import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, mergeProps as _mergeProps, withDirectives as _withDirectives } from "vue";
import { computed } from "vue";
import Icon from "./Icon.vue";
import { isGranted } from "../services/AccessManager";
import { useI18n } from "vue-i18n";
import BadgeComponent from "./BadgeComponent.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Navigation',
    props: {
        type: {},
        items: {},
        translationPrefix: {},
        variant: {},
        iconStyle: {}
    },
    setup(__props) {
        const props = __props;
        const { t, te } = useI18n();
        const visibleItems = computed(() => props.items
            .filter(item => shouldDisplayItem(item)));
        function itemLabel(item) {
            if (!item.label) {
                return t((props.translationPrefix ?? 'nav.') + item.name);
            }
            if (te(item.label)) {
                return t(item.label);
            }
            return item.label;
        }
        function itemProps(item) {
            if (item.url) {
                return { href: item.url };
            }
        }
        function shouldDisplayItem(item) {
            return !item.permission
                || isGranted(item.permission);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("nav", {
                class: _normalizeClass([(__props.type ?? 'main') + '-nav', (__props.type ?? 'main') + '-nav--' + (__props.variant ?? '')])
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleItems.value, (item) => {
                    return _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(item.url ? 'a' : 'router-link'), _mergeProps({
                        key: item.name,
                        to: item.url ? undefined : { name: item.name },
                        class: (__props.type ?? 'main') + '-nav__item',
                        title: itemLabel(item)
                    }, { ref_for: true }, itemProps(item), {
                        "active-class": (__props.type ?? 'main') + '-nav__item--active'
                    }), {
                        default: _withCtx(() => [
                            (item.navItemComponent)
                                ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.navItemComponent.component), {
                                    key: 0,
                                    item: item
                                }, null, 8, ["item"]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (item.icon)
                                        ? (_openBlock(), _createBlock(Icon, {
                                            key: 0,
                                            name: item.icon,
                                            class: _normalizeClass((__props.type ?? 'main') + '-nav__item-icon'),
                                            "icon-style": __props.iconStyle ?? 'regular'
                                        }, null, 8, ["name", "class", "icon-style"]))
                                        : _createCommentVNode("", true),
                                    _cache[0] || (_cache[0] = _createTextVNode()),
                                    _createElementVNode("span", {
                                        class: _normalizeClass((__props.type ?? 'main') + '-nav__item-text')
                                    }, _toDisplayString(itemLabel(item)), 3),
                                    _cache[1] || (_cache[1] = _createTextVNode()),
                                    (item.badge)
                                        ? (_openBlock(), _createBlock(BadgeComponent, { key: 1 }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.badge), 1)
                                            ]),
                                            _: 2
                                        }, 1024))
                                        : _createCommentVNode("", true)
                                ], 64))
                        ]),
                        _: 2
                    }, 1040, ["to", "class", "title", "active-class"])), [
                        [_vShow, !item.hidden]
                    ]);
                }), 128))
            ], 2));
        };
    }
});
